import useSWR from 'swr';
import { captureException } from '@sentry/nextjs';
import { useCurrentAccountId } from '@zapier/identity';
import { isProduction, zodParse } from '../../../utils';
import { Session, Z_Session } from './types';

export type FetchSessionOptions = {
  baseURL?: string;
  zapsession?: string;
};

export const fetchSession = async (options?: FetchSessionOptions) => {
  const sessionResponse = await fetch(
    `${options?.baseURL ?? ''}/api/v4/session/`,
    options?.zapsession
      ? {
          headers: {
            Cookie: `zapsession=${options.zapsession};`,
          },
        }
      : {},
  );
  if (!sessionResponse.ok) {
    throw new Error(
      `Request to fetch user session failed. Status: ${sessionResponse.status}. Message: ${sessionResponse.statusText}`,
    );
  }
  const session: Session = await sessionResponse
    .json()
    .catch((error) => !isProduction() && console.error(error));

  zodParse(Z_Session, session, 'Session');

  return session;
};

export const useSession = (shouldFetch = true) => {
  const currentAccountId = useCurrentAccountId();

  const { data, error, isLoading } = useSWR(
    `/api/v4/session/${shouldFetch}`,
    () => {
      return shouldFetch ? fetchSession() : null;
    },
  );

  if (error) {
    !isProduction() && console.error(error);
    captureException(error);
  }

  return {
    data: data
      ? {
          ...data,
          current_account_role:
            data.roles?.find((role) => role.account_id === currentAccountId)
              ?.role ?? '',
        }
      : null,
    error,
    isLoading,
  };
};
